<template>
    <div class="login_body">
        <el-image class="login_ch_bd" :src="loginImg" ></el-image>
        <div class="login_bd_con">
            <div class="login_bd">
                <div class="login_tit">
                    <div class="login_tit_span">知夏医疗</div>
                    <div class="login_tit_info">ADMIN USER LOGIN </div>
                </div>
                <div class="login_list_con">
                    <el-input class="login_input w-50 m-2" v-model="loginForm.username" prefix-icon="Iphone" size="large"
                              @keyup.enter="handleLogin" placeholder="请输入登录手机号"></el-input>
                </div>
                <div class="login_list_con">
                    <el-input class="login_input w-50 m-2" v-model="loginForm.code" prefix-icon="Message"  size="large"
                              @keyup.enter="handleLogin" placeholder="请输入短信验证码"></el-input>
                    <div class="login-sms-code" @click="getSmsCode">{{ smsCodeText }}</div>
                </div>
                <el-button class="login_list_btn" type="primary" size="large" @click="handleLogin()" :loading="logining">登录</el-button>
            </div>
        </div>

        <div class="bot_btn_con flex_c_col">
            <div class="bot_btn">Copyright © 2018-{{ year }} 知夏中医 All Rights Reserved.</div>
            <a class="bot_btn" href="https://beian.miit.gov.cn" target="_blank">豫ICP备2022021545号-1</a>
        </div>
    </div>
</template>

<script>
    import login from "@/assets/scripts/login/login";
    export default login
</script>

<style scoped>
@import "@/assets/styles/style.scss";
</style>